import React, { useEffect, useState } from 'react';

// redux
import { useSelector } from 'react-redux';
import { selectAltPickupJobList } from '_redux/slices/timeline/timeline-data';
import { selectThirtyMinLayout } from "_redux/slices/timeline/timeline-control";
import { selectSelectedTask, selectSelectedTasksList, selectSelectedMultiplePAXTask } from "_redux/slices/timeline/selected-task";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// custom components
import JobCard from '../job-card';
import { selectBookingType } from '_redux/slices/timeline/timeline-areas';

const AltPickupList = (props) => {

    const [clicked, setClicked] = useState([]);

    let flightNumber = props?.flight?.flightNumber || '';
    if (flightNumber.includes('U2')) {
        flightNumber = flightNumber.replace('U2', 'EZY');
    }

    const altPickupJobs = useSelector(selectAltPickupJobList(props?.flight?.flightNumber));
    const thirtyMinLayout = useSelector(selectThirtyMinLayout);
    const jobsType = useSelector(selectBookingType);
    
    // OPTIMIZED: Get these once and pass to all JobCards to reduce Redux subscriptions
    const selectedTask = useSelector(selectSelectedTask);
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const usedTheme = useSelector(selectUsedTheme);
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);

    return (
        <div>

            {altPickupJobs === null || altPickupJobs.length === 0 || (!jobsType?.includes("ALTPickUp") && !jobsType?.includes("all")) ? null :
                <>
                    <div style={{
                        backgroundColor: 'purple',
                        textAlign: 'left',
                        padding: '5px',
                    }}>
                        <span
                            style={{
                                textAlign: 'left',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: 0,
                                margin: 0,
                            }}
                        >
                            {flightNumber} {' - '}{'Alt Pickups'}
                        </span>
                    </div>

                    {/* list of bookings */}
                    <div style={{ padding: '4px', margin: '2px 0' }}>
                        {altPickupJobs.map((job, index) => (
                            <JobCard
                                key={job._id || index}
                                job={job}
                                index={index}
                                timelineJobs={true}
                                flightData={props.flight}
                                clicked={clicked}
                                setClicked={setClicked}
                                thirtyMinLayout={thirtyMinLayout}
                                selectedTask={selectedTask}
                                selectedTasksList={selectedTasksList}
                                usedTheme={usedTheme}
                                selectedMultiplePAXTask={selectedMultiplePAXTask}
                                showFullCard={true}
                            />
                        ))}
                    </div>
                </>
            }

        </div>
    );
};

export default AltPickupList;
